import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";

import PageTitle from "../../ui/PageTitle/PageTitle";
import AdministratorAdd from "../../components/AdministratorAdd";
import AdministratorTable from "../../components/AdministratorTable";

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(1),
  },
  fixedHeight: {
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
}));

export default function Administrator() {
  const classes = useStyles();

  return (
    <main className={classes.content}>
      <div className={classes.appBarSpacer} />
      <PageTitle title={"Administrators Management"} />
      <Container maxWidth="lg" className={classes.container}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12} lg={12}>
            <AdministratorAdd />
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <AdministratorTable />
          </Grid>
        </Grid>
      </Container>
    </main>
  );
}
